import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Heading1 from '../titles/Heading1';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import GenericParagraph from '../paragraphs/Paragraph.jsx';
import VisibilitySensor from 'react-visibility-sensor';

function BlockEntryItems(props, translate, currentLanguage) {
        const content = props.content;
        const elements =  Object.keys(content).map(function(keyName, keyIndex) {
            return (
                <div key={keyIndex} className="blog-article-container">

                        <div className="tags">
                            <h4><i className="fa fa-tag"></i>{content[keyName].tags}</h4>
                        </div>
                        <div className="title">
                            <Link className="blog-title" to={"article#"+content[keyName].link_to_article }>
                                <Heading1 title={ content[keyName].title } />
                            </Link>
                            <div className="entry-details">
                                <span className="author"><i className="fa fa-user"></i>{ content[keyName].author }</span>
                                <span className="date"><i className="fa fa-calendar"></i>{ content[keyName].date }</span>
                            </div>
                        </div>
                        
                        {/* with image */}
                        { typeof content[keyName].image !== 'undefined' &&
                            <div className="body blog-image-section">
                                <div className="image">
                                    <img className="img-responsive" src={'images/'+ content[keyName].image} alt={ content[keyName].title } />
                                    <GenericParagraph text={ content[keyName].short_entry }/>
                                </div>
                                <div className="content">
                                    <Link to={ "article#"+content[keyName].link_to_article } className="read-more">{ props.readMore }</Link>
                                </div>
                            </div>   
                        }

                        {/* without image */}
                        { typeof content[keyName].image === 'undefined' &&
                            <div className="body">
                                <GenericParagraph text={ content[keyName].short_entry }/>
                                <Link to={ "article#"+content[keyName].link_to_article } className="read-more">{ props.readMore }</Link>
                            </div>  
                        }

                </div>              
            )
        }) 
      return (
        <Col md={8} >
          {elements}
        </Col> 
      )
}

class BlockEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['animate-box'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };      
    render() {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                <BlockEntryItems content={ this.props.content } className={ this.state.animationClasses.join(' ') } style={ { opacity : 0 } } readMore={ this.props.readMore }/>
            </VisibilitySensor>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(BlockEntry);





// WEBPACK FOOTER //
// ./src/components/aside/blockentry.jsx